/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useFormatters } from "../../hooks/useFormatters";
import { formatDuration as formatDurationUtil } from "../../utils/helpers/formatters";

const FormatDuration = ({ value, type }) => {
  const { FormatDuration } = useFormatters();

  return FormatDuration({ value, type });
};

FormatDuration.TYPE = formatDurationUtil.TYPE;

export default FormatDuration;
